import { WorkItemBold } from './workitem-bold';
import { WorkItemTypes } from '../constants/workitem-types';
import { AsyncMessageItem } from '../interfaces/async-message-item.interface';

export class WorkItemAsyncMessage extends WorkItemBold implements AsyncMessageItem {
  public readonly type: string = WorkItemTypes.ASYNC_MESSAGE;
  public messageInitialLoadIsFinished: boolean;

  Name: string;
  Created?: string;
  IsAnswered?: boolean;
  IdleState?: boolean;
  IconID: string;

  constructor(workItem) {
    super(workItem);
    this.IdleState = workItem.IdleState;
    this.keepAlive = false;
  }
}
